import { Scene } from "phaser";

export default class Help extends Scene {

    constructor() {
        super({ key: "Help" });
    }

    init(data) {
        // this.fullPreviousScene = data.scene;
        this.previousScene = data.scene;

        this.textHelp = 'test';
    }

    preload() {
    
        if (this.sys.game.device.os.desktop) {
            this.isMobile = false;
        }
        else {
            this.isMobile = true;
        }


    }
    create() {

        const screenCenterX = this.cameras.main.worldView.x + this.cameras.main.width / 2;
        const screenCenterY = this.cameras.main.worldView.y + this.cameras.main.height / 2;

        this.cameras.main.setBackgroundColor('#333333');

        const w = this.textures.get('backgroundSettings').getSourceImage().width;
        const h = this.textures.get('backgroundSettings').getSourceImage().height;

        let scaleX = this.cameras.main.width / w;
        let scaleY = this.cameras.main.height / h;
        let scale1 = Math.max(scaleX, scaleY)
        this.imageBackground = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, `backgroundSettings`).setScale(scale1).setScrollFactor(0);
        // this.graphics = this.add.graphics();

        // this.graphics.fillStyle(0x252932, 1);
        // this.graphics.lineStyle(3, 0x0a0b0f, 1);

        this.imagePause = this.add.image((screenCenterX /2) - 60, (screenCenterY/ 2) - 60, `menu-pause`).setScale(3.5).setOrigin(0, 0).setScrollFactor(0);


        //  32px radius on the corners
        // this.graphics.fillRoundedRect(screenCenterX /2, screenCenterY/ 2, screenCenterX, screenCenterY - 50, 10);
        // this.graphics.strokeRoundedRect(screenCenterX / 2 , screenCenterY /2 , screenCenterX, screenCenterY - 50, 10);

        switch(this.previousScene) {
            case 'Hallway': 
                this.textHelp = `To complete the game, you need to collect at least 7 lightsticks to unlock the final door. You don’t have to complete all levels. Each door (level) contains a lightstick, so find them all!\n\n If you manage to find all the lightsticks in every level (12 in total), a special surprise awaits you at the door at the end of the hallway.`;
                break;
            case 'Game1':
                this.textHelp = `Avoid being found by the person chasing you. Don't let him catch you.\n\nHint: An old friend of yours has the lightstick.\n\nPress the space bar/action button to pick up the lightstick.`;
                break;
            case 'Game2':
                this.textHelp = `Now that he knows you're here, he's heading straight towards you. Escape, but first find your lightstick!\n\nHint: Search for your lightstick where your reflection keeps a secret.\n\nPress the space bar/action button to pick up the lightstick.`;
                break;
            case 'Game3':
                this.textHelp = `Capture the spider before time runs out.\nPress the space bar/action button to catch the spider.\n\nHint: After catching the spider, the lightstick will be waiting for you at the table.\n\nPress the space bar/action button to pick up the lightstick.`;
                break;
            case 'Game4':
                this.textHelp = "Approach the portal. Once inside the mansion, find the lady. When she disappears, be careful... she will turn into a spider! \n\nDon't let the spider touch you. \nYou must interact with the lady for the lightstick to appear.\n\n" +
                "Hint: Your lightstick might have some cobwebs.\n\n Press the space bar/action button to pick up the lightstick.";
                break;
            case 'Game5':
                this.textHelp = "Enter the building at the end of the street.\nOnce inside, you must find 3 hidden toys (Press the space bar/action button to pick up the toy). \nEach one unlocks a part of the map to progress, \nbut be careful, there's a time limit.\n\n" +
                "Hint: Your lightstick awaits you at the end of the path.\n\nPress the space bar/action button to pick up the lightstick.";
                break;
            case 'Game6':
                this.textHelp = `Play the 'piri' (space bar/action button).\n\nA person identical to you will appear... You need to catch her (space bar/action button) before she disappears, so be quick!\n\nHint: Once you catch your clone, your lightstick will appear.`;
                break;
            case 'Game7':
                this.textHelp = `This level can only be completed with a specific member (refer to the Deja Vu MV). \n\n-If you select any of the other 6 members,\nyou won’t be able to progress.\n-If you chose the correct member: explore the map and use the space bar (or action button) to interact with the other members scattered throughout the map.\n\nHint: And now, I’m in my deja vu..`;
                break;
            case 'Game8':
                this.textHelp = `Interact with the purple sphere using the spacebar/action button.\n\nFour enemies will spawn across the map, and you must defeat them. \nEach enemy will drop a mask fragment—collect them all.\nOnce you’ve gathered every piece, search for the complete mask scattered across the map. When you find it, use the spacebar/action button to pass through the tree.`;
                break;
            case 'Game9':
                this.textHelp = `Run. Avoid the arrows.`;
                break;
            case 'Game10':
                this.textHelp = `Collect all the cups before time runs out! Use the spacebar/action button to grab them.\n\nHint: The tree holds the key to your quest.`;
                break;
            case 'Game11':
                this.textHelp = `Search for the clones of the other members and defeat them by pressing the spacebar/action button. But be careful... your own clone will be chasing you the entire time!\n\nHint: What you're looking for is where you started (in the lobby).`;
                break;
            case 'Game12':
                this.textHelp = `Just run and… \n\n\n\nPlease someone fight for us`;
                break;
        }
        // this.add.bitmapText(screenCenterX + 5, screenCenterY - 60, 
        //     'pixelfont', "help".toUpperCase(), 10, 1).setTint(0xffffff).setDepth(1).setScrollFactor(0).setOrigin(0.5).setVisible(false)
        this.textPausa = this.add.bitmapText(screenCenterX + 5, screenCenterY - 40, 
            'pixelfont', "help".toUpperCase(), 20, 1).setTint(0xffffff).setDepth(1).setOrigin(0.5);
        this.textHome = this.add.bitmapText(screenCenterX , screenCenterY + 30, 
            'pixelfont', this.textHelp.toUpperCase(), 10, 1).setTint(0xffffff).setDepth(1).setOrigin(0.5).setVisible(true).setMaxWidth(screenCenterX + 70)
        // this.textRestart= this.add.text(screenCenterX, screenCenterY - 70, 
        //     `Select the option you want to restore`.toUpperCase(), 
        //     { font: "20px CustomFont", fill: "#FFF", stroke: "#101820", strokeThickness: 6, align: 'center', wordWrap: {width: screenCenterX - 25} }).setOrigin(0.5).setVisible(false)
        // this.textRestartCharacter= this.add.text(screenCenterX, screenCenterY - 30, 
        //     `Restart character`.toUpperCase(), 
        //     { font: "20px CustomFont", fill: "#f2c763	", stroke: "#101820", strokeThickness: 6, align: 'center', wordWrap: {width: screenCenterX - 25} }).setOrigin(0.5).setVisible(false).setInteractive()
        // this.textRestartCharacter2= this.add.text(screenCenterX, screenCenterY, 
        //         `Restart all proccess`.toUpperCase(), 
        //         { font: "20px CustomFont", fill: "#f2c763	", stroke: "#101820", strokeThickness: 6, align: 'center', wordWrap: {width: screenCenterX - 25} }).setOrigin(0.5).setVisible(false).setInteractive()
        // this.textCharacter= this.add.text(screenCenterX, screenCenterY - 45, 
        //     `Do you want to continue? \nThe only effect will be the character change, \nall your progress remains the same.`.toUpperCase(), 
        //     { font: "15px CustomFont", fill: "#FFF", stroke: "#101820", strokeThickness: 6, align: 'center', wordWrap: {width: screenCenterX - 25} }).setOrigin(0.5).setVisible(false)
        
        // this.textRestartAll= this.add.text(screenCenterX, screenCenterY - 45, 
        //     `Do you want to continue? \nyou will lose all your progress and return \nto the character selection screen. \nthis restart everything`.toUpperCase(), 
        //     { font: "15px CustomFont", fill: "#FFF", stroke: "#101820", strokeThickness: 6, align: 'center', wordWrap: {width: screenCenterX - 25} }).setOrigin(0.5).setVisible(false)


        // this.play = this.add.image(screenCenterX - 100, screenCenterY + 20,'play').setScale(1.5).setInteractive({ useHandCursor: true }).setDepth(1);
        // this.soundOn = this.add.image(screenCenterX - 35, screenCenterY + 20, 'soundOn').setScale(1.5).setInteractive({ useHandCursor: true }).setVisible(false).setDepth(1);
        // this.soundOff = this.add.image(screenCenterX - 35, screenCenterY + 20, 'soundOff').setScale(1.5).setInteractive({ useHandCursor: true }).setVisible(false).setDepth(1);
        // this.home = this.add.image(screenCenterX + 35, screenCenterY + 20, 'home').setScale(1.5).setInteractive({ useHandCursor: true }).setVisible(false).setDepth(1);
        // this.restart = this.add.image(screenCenterX + 100, screenCenterY + 20, 'restart').setScale(1.5).setInteractive({ useHandCursor: true }).setVisible(false).setDepth(1);
        this.cancel = this.add.image(screenCenterX, screenCenterY + 125, 'cancel').setScale(1).setInteractive({ useHandCursor: true }).setVisible(true).setDepth(1);
        // this.confirm = this.add.image(screenCenterX + 35, screenCenterY + 20, 'confirm').setScale(1.5).setInteractive({ useHandCursor: true }).setVisible(false).setDepth(1);


        // if(this.previousScene === 'Start') {
        //     this.play.x = screenCenterX - 35;
        //     this.play.visible = true;
        //     this.soundOn.x = screenCenterX + 35;
        //     this.soundOff.x = screenCenterX + 35;
            
        // } else if(this.previousScene === 'Hallway'){
        //     this.play.x = screenCenterX - 65;
        //     this.play.visible = true;
        //     this.soundOn.x = screenCenterX ;
        //     this.soundOff.x = screenCenterX;
        //     this.restart.x = screenCenterX + 65;
        //     this.restart.visible = true;

        // } else {
        //     this.restart.visible = true;
        //     this.home.visible = true;
        // }

        // this.play.on('pointerdown', () => {
        //     this.play.setAlpha(0.4)
        // }).on('pointerup', () => {
        //     this.scene.resume(this.previousScene);
        //     this.scene.stop();
        //     this.play.setAlpha(1)

        // });

        // this.soundOn.on('pointerdown', () => {
        //     this.soundOn.setAlpha(0.4)
        // }).on('pointerup', () => {
        //     localStorage.setItem('sound', 0);
        //     this.soundOn.visible = false;
        //     this.soundOff.visible = true;
        //     this.soundOn.setAlpha(1)

        // });

        // this.soundOff.on('pointerdown', () => {
        //     this.soundOff.setAlpha(0.4)
        // }).on('pointerup', () => {
        //     localStorage.setItem('sound', 1);
        //     this.soundOn.visible = true;
        //     this.soundOff.visible = false;
        //     this.soundOff.setAlpha(1)

        // });

        // this.home.on('pointerdown', () => {
        //     this.home.setAlpha(0.4)
        // }).on('pointerup', () => {
        //     this.textPausa.visible = false;
        //     this.play.visible = false;
        //     this.soundOn.visible = false;
        //     this.soundOff.visible = false;
        //     this.home.visible = false;
        //     this.restart.visible = false;
        //     this.textHome.visible = true;
        //     this.confirm.visible = true;
        //     this.cancel.setX(screenCenterX - 35);
        //     this.cancel.setY(screenCenterY + 20);
        //     this.cancel.visible = true;
        //     this.home.setAlpha(1)

        // });

        // this.restart.on('pointerdown', () => {
        //     this.restart.setAlpha(0.4)
        // }).on('pointerup', () => {
        //     this.textPausa.visible = false;
        //     this.play.visible = false;
        //     this.soundOn.visible = false;
        //     this.soundOff.visible = false;
        //     this.home.visible = false;
        //     this.restart.visible = false;
        //     this.textRestart.visible = true;
        //     this.textRestartCharacter.visible = true;
        //     this.textRestartCharacter2.visible = true;
        //     // this.confirm.visible = true;
        //     this.cancel.setX(screenCenterX)
        //     this.cancel.setY(screenCenterY + 40)
        //     this.cancel.visible = true;
        //     this.restart.setAlpha(1)

        // });

        // this.confirm.on('pointerdown', () => {
        //     this.confirm.setAlpha(0.4)
        // }).on('pointerup', () => {
        //     this.confirm.setAlpha(1)
        //     this.scene.stop();
        //     if(this.textHome.visible) {
        //         this.scene.resume(this.previousScene, {goHome: true});

        //     }

        //     if(this.textRestartAll.visible) {
        //         localStorage.removeItem('noL');
        //         localStorage.removeItem('ch');
        //         localStorage.removeItem('sI');
        //         this.scene.resume(this.previousScene, {goStart: true});


        //     }
            
        //     if(this.textCharacter.visible) {
        //         localStorage.removeItem('ch');
        //         this.scene.resume(this.previousScene, {goStart: true});
        //     }
        // });

        // this.textRestartCharacter.on('pointerdown', () => {
        //     this.textRestartCharacter.setAlpha(0.4)
        // }).on('pointerup', () => {
        //     this.textPausa.visible = false;
        //     this.play.visible = false;
        //     this.soundOn.visible = false;
        //     this.soundOff.visible = false;
        //     this.home.visible = false;
        //     this.restart.visible = false;
        //     this.textCharacter.visible = true;
        //     this.textRestart.visible = false;
        //     this.textRestartCharacter.visible = false;
        //     this.textRestartCharacter2.visible = false;
        //     this.confirm.visible = true;
        //     this.cancel.setX(screenCenterX - 35);
        //     this.cancel.setY(screenCenterY + 20);
        //     this.cancel.visible = true;
        //     this.textRestartCharacter.setAlpha(1);
        // });
        
        // this.textRestartCharacter2.on('pointerdown', () => {
        //     this.textRestartCharacter2.setAlpha(0.4)
        // }).on('pointerup', () => {
        //     this.textPausa.visible = false;
        //     this.play.visible = false;
        //     this.soundOn.visible = false;
        //     this.soundOff.visible = false;
        //     this.home.visible = false;
        //     this.restart.visible = false;
        //     this.textRestartAll.visible = true;
        //     this.textRestart.visible = false;
        //     this.textRestartCharacter.visible = false;
        //     this.textRestartCharacter2.visible = false;
        //     this.confirm.visible = true;
        //     this.cancel.setX(screenCenterX - 35);
        //     this.cancel.setY(screenCenterY + 20);
        //     this.cancel.visible = true;
        //     this.textRestartCharacter2.setAlpha(1);
        // });

        this.cancel.on('pointerdown', () => {
            this.cancel.setAlpha(0.4)
        }).on('pointerup', () => {
            this.cancel.setAlpha(1)
            this.textPausa.visible = true;
            this.scene.stop();
            this.scene.resume(this.previousScene);
        });

        
    }
    
    update() {


    }


}